import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useAtom } from 'jotai';
import { searchStrAtom } from './atoms';

function Header() {
  const [searchStr, setSearchStr] = useAtom(searchStrAtom)
  const handleChange = (e) => setSearchStr(e.target.value)

  return (
    <Input
      placeholder="input to search"
      value={searchStr}
      allowClear
      onChange={handleChange}
      suffix={<SearchOutlined />}
    />
  );
}

export default Header;
